import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../shared/MainLayout';
import Home from '../views/Home';
import About from '../views/About';
import MissionVision from '../views/MissionVision';
import Infrastructure from '../views/Infrastructure';
import Services from '../views/Services';
import Gallery from '../views/Gallery';
import Contact from '../views/Contact';
import Login from '../views/Login';

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}> 
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/mission-vision" element={<MissionVision />} />
        <Route path="/infrastructure" element={<Infrastructure />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
